import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';
import { useSnackbar } from 'notistack';
import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useAsyncFn } from 'react-use';
import { PublicationStatus } from '@uno/common-cms';
import { addAbsoluteUrlsToUrlDescriptions, filterDisplayableUrls, openWindow } from 'libs/content/utils';
import { getFirstLoadContent, getUrls, updatePreview, updateUrls } from 'redux/content';
import { createPreview, fetchGetPageMetaData, generateUrls } from 'services/networking/navigation';
import contentToEnvelope from '../utils/contentToEnvelope';

var useOpenPreview = function useOpenPreview() {
  var _useFormContext;

  var intl = useIntl();
  var dispatch = useDispatch();

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useSelector = useSelector(getUrls),
      contentUrls = _useSelector.value;

  var _useSelector2 = useSelector(getFirstLoadContent),
      firstLoadContent = _useSelector2.value;

  var _ref = (_useFormContext = useFormContext()) !== null && _useFormContext !== void 0 ? _useFormContext : {},
      getValues = _ref.getValues;

  var openFirstDisplayableUrl = useCallback(function (urls, params) {
    var _previewUrls$;

    var previewUrls = filterDisplayableUrls(urls);
    var previewAbsoluteUrl = previewUrls === null || previewUrls === void 0 ? void 0 : (_previewUrls$ = previewUrls[0]) === null || _previewUrls$ === void 0 ? void 0 : _previewUrls$.absoluteUrl;

    if (!isString(previewAbsoluteUrl)) {
      enqueueSnackbar(intl.formatMessage({
        id: 'content.edit.call-to-actions.preview.error'
      }), {
        variant: 'error'
      });
      return;
    }

    openWindow(previewAbsoluteUrl, params);
  }, [intl, enqueueSnackbar]);

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(contentId) {
      var _yield$fetchGetPageMe;

      var urls, previewUrls;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(updateUrls({
                loading: true
              }));
              _context.next = 3;
              return fetchGetPageMetaData(contentId);

            case 3:
              _context.t1 = _yield$fetchGetPageMe = _context.sent;
              _context.t0 = _context.t1 !== null;

              if (!_context.t0) {
                _context.next = 7;
                break;
              }

              _context.t0 = _yield$fetchGetPageMe !== void 0;

            case 7:
              if (!_context.t0) {
                _context.next = 11;
                break;
              }

              _context.t2 = _yield$fetchGetPageMe;
              _context.next = 12;
              break;

            case 11:
              _context.t2 = [];

            case 12:
              urls = _context.t2;
              dispatch(updateUrls({
                loading: false
              }));
              previewUrls = addAbsoluteUrlsToUrlDescriptions(urls);
              openFirstDisplayableUrl(previewUrls);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [dispatch, openFirstDisplayableUrl]),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      error = _useAsyncFn2[0].error,
      doFetchUrls = _useAsyncFn2[1];

  useEffect(function () {
    if (error !== undefined) {
      enqueueSnackbar(intl.formatMessage({
        id: 'content.edit.call-to-actions.preview.error'
      }), {
        variant: 'error'
      });
      dispatch(updateUrls({
        loading: false
      }));
    }
  }, [error, enqueueSnackbar, intl, dispatch]);
  var onlineHandler = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(contentId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(contentId !== undefined)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return doFetchUrls(contentId);

            case 3:
              return _context2.abrupt("return");

            case 4:
              openFirstDisplayableUrl(contentUrls !== null && contentUrls !== void 0 ? contentUrls : []);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [contentUrls, openFirstDisplayableUrl, doFetchUrls]);
  var offlineHandler = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var urls, preview, previewUrls;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            dispatch(updatePreview({
              loading: true
            }));
            _context3.prev = 1;

            if (firstLoadContent) {
              _context3.next = 4;
              break;
            }

            throw new Error();

          case 4:
            _context3.next = 6;
            return generateUrls(contentToEnvelope(_objectSpread(_objectSpread({}, firstLoadContent), getValues !== undefined ? {
              contentData: getValues()
            } : {})));

          case 6:
            urls = _context3.sent;

            if (!(isNil(urls) || isNil(urls[0]))) {
              _context3.next = 9;
              break;
            }

            throw new Error();

          case 9:
            _context3.next = 11;
            return createPreview({
              siteId: urls[0].siteId,
              hostId: urls[0].hostId,
              path: urls[0].path,
              mainChunkId: firstLoadContent.id
            });

          case 11:
            preview = _context3.sent;
            previewUrls = addAbsoluteUrlsToUrlDescriptions(urls);
            openFirstDisplayableUrl(previewUrls, {
              previewToken: preview.previewToken
            });
            _context3.next = 19;
            break;

          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](1);
            enqueueSnackbar(intl.formatMessage({
              id: 'content.edit.call-to-actions.preview.error'
            }), {
              variant: 'error'
            });

          case 19:
            dispatch(updatePreview({
              loading: false
            }));

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 16]]);
  })), [dispatch, firstLoadContent, getValues, openFirstDisplayableUrl, enqueueSnackbar, intl]);
  var doOpenPreview = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
      var status, contentId;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              status = _ref5.status, contentId = _ref5.contentId;

              if (!(status === PublicationStatus.ONLINE)) {
                _context4.next = 5;
                break;
              }

              _context4.next = 4;
              return onlineHandler(contentId);

            case 4:
              return _context4.abrupt("return");

            case 5:
              _context4.next = 7;
              return offlineHandler();

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x3) {
      return _ref6.apply(this, arguments);
    };
  }(), [onlineHandler, offlineHandler]);
  return {
    doOpenPreview: doOpenPreview
  };
};

export default useOpenPreview;